module.exports = __webpack_public_path__ + "img/icon_search_helmet_alarmpre.8281f6a9.png";